export default "__VITE_ASSET__qTgnN7O2__"